import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import BottomNav, { SideNav } from "./BottomNav";
import Footer from "./Footer";

/**
 * Sidebar offset is applied on an OUTER wrapper (not on <main>) so that
 * the max-w-7xl / px-* utilities on <main> stay independent. Both
 * `md:pl-64` and `lg:px-8` target `padding-left`; when placed on the
 * same element Tailwind's `@media (min-width: 1024px)` block ships
 * AFTER the md block, so `lg:px-8` wins and shrinks the offset back to
 * 32px — the fixed sidebar (w-56 = 224px) then covers ~190px of every
 * page's content. Splitting into two elements eliminates the collision.
 */
export default function Layout() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="min-h-screen bg-[#F8F9FA] text-slate-900 flex flex-col">
      <Header />
      <SideNav />
      <div
        data-testid="app-main-offset"
        className={`flex-1 flex flex-col ${isAdmin ? "" : "md:pl-64"}`}
      >
        <main
          data-testid="app-main"
          className={`flex-1 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 w-full ${
            isAdmin ? "pb-10" : "pb-28 md:pb-10"
          }`}
        >
          <Outlet />
        </main>
        {!isAdmin && <Footer />}
      </div>
      <BottomNav />
    </div>
  );
}
